export default __webpack_public_path__ + "static/logosampoerna-998bb69600bfbfc38fdc86b050c832d7.jpg";